// Helper to fetch report previews from backend for specific report types.
// reportType: 'premiumDue' | 'premiumOutstanding' | 'lapsed' | 'policy'
// fromDate/toDate should be strings (YYYY-MM-DD or Date-compatible)

function toYYYYMMDD(v) {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  if (Number.isNaN(d.getTime())) return null;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export default async function fetchPolicyReport(reportType = 'policy', fromDate = null, toDate = null, extra = {}) {
  const base = '/policy-management';
  let path = '/preview-policy-report';
  switch ((reportType || '').toString().toLowerCase()) {
    case 'premiumdue':
    case 'premium_due':
    case 'premium-due':
      path = '/preview-premium-due-report';
      break;
    case 'premiumoutstanding':
    case 'premium_outstanding':
    case 'premium-outstanding':
      path = '/preview-premium-outstanding-report';
      break;
    case 'lapsed':
    case 'lapsedpolicies':
    case 'lapsed-policies':
      path = '/preview-lapsed-policies-report';
      break;
    default:
      path = '/preview-policy-report';
  }

  const params = new URLSearchParams();
  const f = toYYYYMMDD(fromDate);
  const t = toYYYYMMDD(toDate);
  if (f) params.append('fromDate', f);
  if (t) params.append('toDate', t);
  // always indicate we're filtering by FUP for these specialized reports
  if (['premiumdue','premium_due','premium-due','premiumoutstanding','premium_outstanding','premium-outstanding','lapsed','lapsedpolicies','lapsed-policies'].includes((reportType||'').toString().toLowerCase())) {
    params.append('filterByDate', 'fup');
  }
  // merge extra params
  Object.keys(extra || {}).forEach(k => {
    const v = extra[k];
    if (v !== undefined && v !== null) params.append(k, String(v));
  });

  const url = `${base}${path}?${params.toString()}`;

  const resp = await fetch(url, { credentials: 'same-origin' });
  if (!resp.ok) {
    const txt = await resp.text().catch(() => null);
    throw new Error(`Report fetch failed: ${resp.status} ${resp.statusText} ${txt || ''}`);
  }

  const data = await resp.json();
  return data;
}
